/**
 * @flow
 */
import React from 'react';

import { Input, Button } from '../../../../components';
import {
  ContentPersonal,
  InfoTitle,
  InfoMain,
  Header,
  UserAvatar,
  OptionProfile,
  DownloadAvatar,
  DeleteAvatar,
  Main,
  LeftBlockInfo,
  RightBlockInfo,
  TitleInfoProgile,
  InfoHeader,
} from './PersonalInfoStyled';

type PersonalInfoPropsType = {
    myAvatar: (any) => void,
    saveIMG?: any,
    statusCheckInfo: (any) => void,
    setSaveIMG: (any) => void,
    firstName: string,
    lastName: string,
    position: string,
    login: string,
    phoneNumber: string,
    email: string,
    setFirstName: (any) => void,
    setLastName: (any) => void,
    setPhoneNumber: (any) => void,
    setEmail: (any) => void,
    saveProfileData: (any) => void,
    // saveResualt: any,
};

export default function PersonalInfo(props: PersonalInfoPropsType) {
  return (
    <ContentPersonal>
      <InfoHeader>
        <InfoTitle>
          <span>Личная</span>
          <span>информация</span>
        </InfoTitle>
        <Button
          clicked={() => {
            console.log('clicked');
            props.saveProfileData();
          }}
          mode="blue"
        >Сохранить
        </Button>
      </InfoHeader>
      <InfoMain>
        <Header>
          <UserAvatar avatar={props.saveIMG} />
          <OptionProfile>
            <DownloadAvatar>
              <input
                type="file"
                name="photo"
                multiple=""
                accept="image/*,image/jpeg"
                onChange={props.myAvatar}
              />
            </DownloadAvatar>
            <DeleteAvatar onClick={() => {
              props.setSaveIMG();
            }}
            />
          </OptionProfile>
        </Header>
        <Main>
          <LeftBlockInfo>
            <TitleInfoProgile>Имя</TitleInfoProgile>
            <Input
              type="text"
              value={props.firstName}
              placeholder="Имя работника"
              changed={(value) => {
                props.setFirstName(value);
                setTimeout(() => {
                  props.statusCheckInfo(value.lenght);
                }, 0);
              }}
            />
            <TitleInfoProgile>Должность</TitleInfoProgile>
            <Input
              type="text"
              placeholder="Должность"
              value={props.position}
              changed={value => console.log(value)}
              readOnlyState
            />
            <TitleInfoProgile>Телефон</TitleInfoProgile>
            <Input
              type="text"
              placeholder="Телефон работника"
              value={props.phoneNumber}
              changed={(value) => {
                props.setPhoneNumber(value);
                setTimeout(() => {
                  props.statusCheckInfo(value.lenght);
                }, 0);
              }}
            />
          </LeftBlockInfo>
          <RightBlockInfo>
            <TitleInfoProgile>Фамилия</TitleInfoProgile>
            <Input
              type="text"
              placeholder="Фамилия работника"
              value={props.lastName}
              changed={(value) => {
                props.setLastName(value);
                setTimeout(() => {
                  props.statusCheckInfo(value.lenght);
                }, 0);
              }}
            />
            <TitleInfoProgile>Логин</TitleInfoProgile>
            <Input
              readOnly
              type="text"
              placeholder="Укажите логин"
              value={props.login}
              changed={value => console.log(value)}
              readOnlyState
            />
            <TitleInfoProgile>Электронная почта</TitleInfoProgile>
            <Input
              type="text"
              placeholder="Почта работника"
              value={props.email}
              changed={(value) => {
                props.setEmail(value);
                setTimeout(() => {
                  props.statusCheckInfo(value.lenght);
                }, 0);
              }}
            />
          </RightBlockInfo>
        </Main>
      </InfoMain>
      {/* <PopupSaveResult>
        {props.saveResualt && (<Popup status="Success">Сохранено!</Popup>)}
      </PopupSaveResult> */}
    </ContentPersonal>
  );
}

PersonalInfo.defaultProps = {
  saveIMG: require('../../../../assets/images/default_avatar.png'),
};
